import { BundleProduct } from '../api';

export function calculateProductBundlePrice(bundle: BundleProduct) {
  return bundle.variants
    .reduce((acc, item) => {
      const componentProduct = bundle.bundleConfigs?.componentProductData.find(
        (p) => String(p.productId) === String(item.productId),
      );
      const componentProductQty = componentProduct?.quantity || 1;

      return (acc + Number(item.retailers[0]?.price)) * componentProductQty;
    }, 0)
    .toFixed(2);
}
